import { ComponentRef, Injectable } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { timer } from 'rxjs';
import { ComponentPortal } from '@angular/cdk/portal';

import { ToastType } from '../models/toast-type.enum';
import { ToastComponent } from '../components/toast/toast.component';
import { AnimationDurations } from '../../core/animation/animation';

@Injectable({
  providedIn: 'root'
})
export class McRAIToaster {
  readonly DEFAULT_DURATION = 3000;
  readonly TOAST_HEIGHT = 65;
  readonly TOAST_MAX_WIDTH = 600;

  private _lastActiveToastIndex = 0;
  private _bottomOffset = '';

  constructor(
    private overlay: Overlay
  ) { }

  private _getConfig(): OverlayConfig {
    const config = new OverlayConfig();

    this._bottomOffset = `${this._lastActiveToastIndex++ * this.TOAST_HEIGHT + 5}px`;

    config.positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .bottom(this._bottomOffset);

    config.width = `${this.TOAST_MAX_WIDTH}px`;

    return config;
  }

  private _getPortal(): ComponentPortal<ToastComponent> {
    return new ComponentPortal(ToastComponent);
  }

  private _getToast(reference: ComponentRef<ToastComponent>): ToastComponent {
    return reference.instance;
  }

  private _eatToast(toast: ToastComponent, overlayRef: OverlayRef): void {
    this._lastActiveToastIndex--;

    toast.close();

    timer(parseInt(AnimationDurations.COMPLEX))
      .subscribe(() => overlayRef.dispose());
  }

  private _enumToString(enumArray: any, enumValue: any): string {
    return enumArray[enumValue].toLowerCase();
  }

  public makeToast(text: string, type: ToastType, duration?: number) {
    if (!duration) {
      duration = this.DEFAULT_DURATION;
    }

    const config = this._getConfig();
    const portal = this._getPortal();

    const overlayRef   = this.overlay.create(config);
    const componentRef = overlayRef.attach(portal);
    const instance     = this._getToast(componentRef);

    instance.text   = text;
    instance.type   = this._enumToString(ToastType, type);
    instance.offset = this._bottomOffset;

    instance.open();

    timer(duration)
      .subscribe(() => this._eatToast(instance, overlayRef));
  }

}
